import { render, staticRenderFns } from "./mb-segment-id-input.vue?vue&type=template&id=7c22a234&"
import script from "./mb-segment-id-input.vue?vue&type=script&lang=ts&"
export * from "./mb-segment-id-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports